import { runDemo } from "../shared/demoRunner";
import { createSimplificationScene } from "./scene";

runDemo({ createScene: createSimplificationScene });
